import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#expandable-row" }),
  /*#__PURE__*/_createTextVNode(" Expandable row ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " When the row content is too long and you do not want to display the horizontal scroll bar, you can use the expandable row feature. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              _createVNode("p", null, "State: " + _toDisplayString(props.row.state), 1),
              _createVNode("p", null, "City: " + _toDisplayString(props.row.city), 1),
              _createVNode("p", null, "Address: " + _toDisplayString(props.row.address), 1),
              _createVNode("p", null, "Zip: " + _toDisplayString(props.row.zip), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Date",
            prop: "date"
          }),
          _createVNode(_component_el_table_column, {
            label: "Name",
            prop: "name"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code16), 1)
        ]),
        _: 1
      })
    ])
  ]))
}